const supportedBrowsersRegExp = new RegExp('/Edge?\/13[34]\.0(\.\d+|)|Firefox\/13[56]\.0(\.\d+|)|Chrom(ium|e)\/13[1-4]\.0(\.\d+|)|(Maci|X1{2}).+ Version\/(17\.6|18\.3)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|Chrome.+OPR\/1{2}7\.0\.\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(16[._][67]|17[._][67]|18[._][1-3])([._]\d+|)|Mobile Safari.+OPR\/8(0\.){2}\d+|Android.+Firefox\/137\.0(\.\d+|)|Android.+Chrom(ium|e)\/135\.0(\.\d+|)|SamsungBrowser\/27\.0/');
const isUnsupportedBrowser = function () {
    try {
        if (navigator.userAgent) {
            return !supportedBrowsersRegExp.test(navigator.userAgent);
        }
    }
    catch {
        // Suppress errors
        return undefined;
    }
};

export { isUnsupportedBrowser };
//# sourceMappingURL=index.js.map
